export const getAdminGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return 'Good morning';
  if (hour < 17) return 'Good afternoon';
  return 'Good evening';
};

export const getAdminInsight = ({ overview, growth, pendingActions, unreadMessages }) => {
  if (pendingActions > 0) {
    const parts = [];
    if (overview?.pendingCourseApprovals > 0) {
      parts.push(`${overview.pendingCourseApprovals} course${overview.pendingCourseApprovals > 1 ? 's' : ''}`);
    }
    if (overview?.pendingInstructorApprovals > 0) {
      parts.push(`${overview.pendingInstructorApprovals} instructor${overview.pendingInstructorApprovals > 1 ? 's' : ''}`);
    }
    return {
      badge: 'Action queue',
      headline: `${pendingActions} approval${pendingActions > 1 ? 's' : ''} on deck`,
      body: `Waiting: ${parts.join(' · ')}. A five-minute review keeps creators shipping.`,
      cta: 'Clear the queue',
      tab: 'qoreacademy',
      subTab: overview?.pendingCourseApprovals > 0 ? 'courses' : 'users',
      tone: 'urgent',
    };
  }

  if (unreadMessages > 0) {
    return {
      badge: 'Inbox ping',
      headline: `${unreadMessages} new message${unreadMessages > 1 ? 's' : ''}`,
      body: 'Learners and partners are reaching out — timely replies build trust.',
      cta: 'Open inbox',
      tab: 'messages',
      tone: 'info',
    };
  }

  const userGrowth = growth?.userGrowth ?? 0;
  if (userGrowth > 15) {
    return {
      badge: 'Growth spurt',
      headline: 'Signups are popping off',
      body: `+${userGrowth}% new users this month. Worth a peek at what's converting.`,
      cta: 'Open analytics',
      tab: 'analytics',
      tone: 'success',
    };
  }

  if ((overview?.completionRate ?? 0) >= 60) {
    return {
      badge: 'Learner wins',
      headline: 'Completion rate looks healthy',
      body: `${overview.completionRate}% of enrollments finish — learners are actually finishing what they start.`,
      cta: 'Content analytics',
      tab: 'analytics',
      subTab: 'content',
      tone: 'success',
    };
  }

  return {
    badge: 'Command brief',
    headline: 'All quiet on the flight deck',
    body: `${(overview?.totalUsers || 0).toLocaleString()} users · ${(overview?.totalCourses || 0).toLocaleString()} courses · systems nominal.`,
    cta: 'Explore analytics',
    tab: 'analytics',
    tone: 'calm',
  };
};

export const getHealthScore = (systemHealth) => {
  if (!systemHealth) return null;
  let score = 100;
  Object.values(systemHealth).forEach((m) => {
    if (m?.status === 'warning') score -= 12;
    if (m?.status === 'critical') score -= 28;
    if (m?.percentage > 85 && m?.used != null) score -= 8;
  });
  return Math.max(0, Math.min(100, score));
};

export const ROLE_COLORS = {
  student: '#22d3ee',
  instructor: '#f59e0b',
  admin: '#8b5cf6',
  mentor: '#34d399',
  unknown: '#94a3b8',
};

export const PODIUM_MEDALS = ['🥇', '🥈', '🥉'];